import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Sparkles, ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/context/SubscriptionContext";

export function Paywall({ feature = "This part of EverMind" }) {
  const navigate = useNavigate();
  const { sub } = useSubscription();
  const introUsed = sub?.intro_used;
  const price = introUsed ? (sub?.monthly_price ?? 4.99) : (sub?.intro_price ?? 1.99);

  return (
    <div className="flex min-h-[60vh] items-center justify-center" data-testid="paywall">
      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="max-w-md rounded-3xl border border-border/60 bg-card/60 p-8 text-center backdrop-blur-xl"
      >
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary/15">
          <Lock className="h-6 w-6 text-primary" strokeWidth={1.5} />
        </div>
        <h2 className="font-serif text-2xl">{feature} is part of the full experience</h2>
        <p className="mt-3 text-sm text-muted-foreground">
          Your free plan keeps daily check-ins and your companion (up to {sub?.chat_limit ?? 5} messages a day).
          Unlock everything with EverMind Full.
        </p>
        <div className="mt-6 space-y-2 text-left">
          {["Unlimited companion conversations", "Journaling, insights & mood analytics", "Habits, goals, life story & community"].map((f) => (
            <div key={f} className="flex items-center gap-2 text-sm">
              <Check className="h-4 w-4 flex-shrink-0 text-sage" strokeWidth={2} /> {f}
            </div>
          ))}
        </div>
        <Button
          className="mt-7 w-full rounded-full" size="lg" data-testid="paywall-upgrade-button"
          onClick={() => navigate("/app/subscription")}
        >
          <Sparkles className="mr-2 h-4 w-4" strokeWidth={1.5} />
          {introUsed ? `Subscribe · €${price.toFixed(2)}/mo` : `Try 1 month for €${price.toFixed(2)}`}
          <ArrowRight className="ml-2 h-4 w-4" strokeWidth={1.5} />
        </Button>
        {!introUsed && (
          <p className="mt-3 text-xs text-muted-foreground">then €{(sub?.monthly_price ?? 4.99).toFixed(2)}/month · cancel anytime</p>
        )}
      </motion.div>
    </div>
  );
}
